import { QueryState } from 'src/app/core/models/query.model';
import { ITableColumn } from 'src/app/core/models/table.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query-sentrynel.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { IUtente } from '../core/models/utenti.model';

export const UTENTI_ENDPOINT = 'users';
export const UTENTI_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(UTENTI_ENDPOINT);

export const utentiStateConfig: SignalStoreConfig<QueryState<IUtente>> = {
  initState: {
    list: [],
    sort: {
      field: 'username',
      direction: 'asc'
    }
  }
}

export const UTENTI_COLUMNS: ITableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    field: 'id',
    primaryKey: true,
    visible: false
  },
  {
    name: 'username',
    label: 'Username',
    field: 'username',
  },
  {
    name: 'email',
    label: 'E-Mail',
    field: 'email',
  },
  {
    name: 'level',
    label: 'Livello',
    field: 'level',
    sortable: false,
  },
  {
    name: 'roles',
    label: 'Ruoli',
    field: 'roles',
    sortable: false,
  },
];
